/* globals ENV, API_HOST, PREFIX, EMAIL_SEND, BASE_TITLE, STORAGE_PREFIX */
const env = {
  ENV,
  API_HOST,
  PREFIX,
  EMAIL_SEND,
  BASE_TITLE,
  STORAGE_PREFIX
}

console.log('Env variables:', env)
export default env



// WEBPACK FOOTER //
// /home/ec2-user/esquina/esquina/lib/frontend/env-variables.js